import { render } from "./Merchant-services-en.vue?vue&type=template&id=405c0fe8&scoped=true"
import script from "./Merchant-services-en.vue?vue&type=script&lang=js"
export * from "./Merchant-services-en.vue?vue&type=script&lang=js"

import "./Merchant-services-en.vue?vue&type=style&index=0&id=405c0fe8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-405c0fe8"]])

export default __exports__